import React from 'react';

interface PageHeaderProps {
  title: string;
  /** Short context line — counts, rates, sync time. */
  meta?: React.ReactNode;
  /** Right-aligned controls (segmented control, primary action). */
  actions?: React.ReactNode;
  /** Optional back affordance rendered above the title. */
  back?: React.ReactNode;
}

export function PageHeader({ title, meta, actions, back }: PageHeaderProps) {
  return (
    <div className="mb-4 flex flex-col gap-3 sm:mb-5 sm:flex-row sm:items-center sm:justify-between">
      <div className="min-w-0">
        {back}
        <h1 className="truncate text-[1.25rem] font-semibold tracking-[-0.015em] text-[var(--text-main)] sm:text-[1.5rem]">
          {title}
        </h1>
        {meta && (
          <div className="mt-0.5 flex flex-wrap items-center gap-x-2 gap-y-1 text-[0.8125rem] text-[var(--text-muted)]">
            {meta}
          </div>
        )}
      </div>
      {actions && <div className="flex flex-shrink-0 items-center gap-2">{actions}</div>}
    </div>
  );
}

/** Dot separator for the meta line. */
export function MetaDot() {
  return <span className="text-[var(--text-dim)]">·</span>;
}
